import { UI, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { CardTitle } from '../../../../components/CardTitle';
import { HighlightedInfos } from '../../../../components/HighlightedInfos';
import { ColoredInfoSkeleton, InfoItem } from '../../../../components/InfoItem';
import { ProductCard } from '../../../../components/ProductCard';

export interface QuotationStepLoadingProps {
  productName: string;
  isQuotation: boolean;
}

export const QuotationStepLoading: React.FC<QuotationStepLoadingProps> = ({
  productName,
  isQuotation,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <ProductCard barColor="product.rf">
        <VStack space={Spacing['stack.xxxs']}>
          <CardTitle title={productName} />
          <InfoItem label="Taxa de Compra" loading />
          <InfoItem label="Vencimento" loading />
          <InfoItem label="Aportes" loading />

          <HighlightedInfos
            infos={[
              { label: 'IR Previsto', loading: true },
              { label: 'IOF Previsto', loading: true },
            ]}
          />

          <InfoItem label="Rentabilidade no período" loading />
          <InfoItem label="Saldo Bruto" loading />
          <InfoItem label="Quantidade" loading />
          <InfoItem label="Preço Unitário" loading />
          <InfoItem label="Taxa de Saida" loading />
          <InfoItem label="Valor de Resgate" loading />

          {!!isQuotation && (
            <VStack space={Spacing['stack.quarck']} w="full">
              <UI.Text color="neutral.black" variant="semibold">
                Quantidade desejada
              </UI.Text>

              <ColoredInfoSkeleton w="full" height="40px" />
            </VStack>
          )}

          {!!isQuotation && <ColoredInfoSkeleton w="full" height="40px" />}
        </VStack>
      </ProductCard>

      <HStack alignSelf="end" space={Spacing['inline.xxxs']}>
        <UI.Button variant="secondary" isDisabled>
          Cancelar
        </UI.Button>
        <UI.Button isDisabled>Confirmar</UI.Button>
      </HStack>
    </VStack>
  );
};
